import React from 'react';
const coverage = [{
  label: 'Every week',
  body: 'A Weekly Class Set — plan, warm-up & skill, combo and game — a full class in 4 pages, in 30, 45 and 60-minute versions'
}, {
  label: 'Every combo',
  body: 'Counts in 8s, written in Starter, Core and Stretch, with a “Make It Yours” space for your style'
}, {
  label: 'Music',
  body: 'BPM, style and structure only — teach it to any clean track you are licensed to play'
}, {
  label: 'Mixed-age rooms',
  body: 'Three levels on every Combo Card, so the 6-year-old and the 12-year-old dance the same routine'
}, {
  label: 'Class control',
  body: 'The Freeze-Frame Reset and a ready game every week to get the room back without raising your voice'
}, {
  label: 'Format',
  body: 'Landscape pages that read on a phone mid-class or print for the studio'
}];
const steps = ['Open the week', 'Pick your length', 'Match the level', 'Teach'];
const levels = [{
  name: 'Starter',
  dots: 1,
  color: 'bg-sage'
}, {
  name: 'Core',
  dots: 2,
  color: 'bg-smoke'
}, {
  name: 'Stretch',
  dots: 3,
  color: 'bg-lilac'
}];
export function ProductReveal() {
  return <section aria-labelledby="mechanism-heading" className="w-full border-y-4 border-gold bg-plum-mid" data-id="element-237" data-mp="1f06gzzuwhv39">
      <div className="max-w-5xl mx-auto px-5 py-16 sm:py-20 text-center" data-id="element-238" data-mp="1os2n9y754rik">
        <p className="text-[11px] font-semibold uppercase tracking-[1.8px] text-gold" data-id="element-239" data-mp="1ou6qedx7tmhs">
          The mechanism
        </p>
        <h2 id="mechanism-heading" className="mt-3 font-display font-bold text-white text-3xl sm:text-5xl" data-id="element-240" data-mp="w3f2s4u7u662">
          The Flex-Level Class Method
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base sm:text-lg text-white/75" data-id="element-241" data-mp="161usc3dlh7dg">
          One season of classes, ordered week by week from the first day to the
          final bow. Every class runs the same{' '}
          <span className="font-semibold text-white" data-id="element-242" data-mp="2hgi2akq9v9tw">4-Block Class Flow</span>{' '}
          — Warm Up, Skill, Combo, Play — and every combo is written in
          8-counts in three levels, with a space to make it yours.{' '}
          <span className="font-semibold text-white" data-id="element-243" data-mp="1mszpe8jmz3za">
            One class, three levels, and you finish it.
          </span>
        </p>

        <ul className="mx-auto mt-7 flex max-w-xl flex-wrap justify-center gap-2.5" data-id="element-244" data-mp="21opggl3oi7av">
          {levels.map(level => <li key={level.name} className="flex items-center gap-2 rounded-full border border-plum-line bg-plum-card px-4 py-2" data-id="element-245" data-mp="1924obifdpr69">
              <span className="flex gap-1" data-id="element-246" data-mp="1416zimzv5yvs">
                {Array.from({
              length: level.dots
            }).map((_, i) => <span key={i} className={`h-2 w-2 rounded-full ${level.color}`} data-id="element-247" data-mp="1e1hcq7lwf6ay" data-mpi={i} />)}
              </span>
              <span className="text-[13px] font-semibold text-white" data-id="element-248" data-mp="qbd57p5lameo">
                {level.name}
              </span>
            </li>)}
        </ul>

        <ol className="mx-auto mt-6 flex max-w-3xl flex-wrap items-center justify-center gap-2 sm:gap-3" data-id="element-249" data-mp="lapg590x8fn3">
          {steps.map((step, i) => <li key={step} className="flex items-center gap-2 sm:gap-3" data-id="element-250" data-mp="31r5bpxop9srt" data-mpi={i}>
              <span className="rounded-full bg-gold/15 px-4 py-2 text-[13px] font-semibold text-gold-hover" data-id="element-251" data-mp="2n297kbprkzwh">
                <span className="mr-1.5 font-mono" data-id="element-252" data-mp="2s0j34nfei2im">{i + 1}.</span>
                {step}
              </span>
              {i < steps.length - 1 && <span className="hidden h-px w-5 bg-gold/50 sm:block" data-id="element-253" data-mp="3frg3d2xu3be1" />}
            </li>)}
        </ol>

        <ul className="mt-9 grid gap-2.5 text-left sm:grid-cols-2 lg:grid-cols-3" data-id="element-254" data-mp="36pyt4173y3x9">
          {coverage.map(item => <li key={item.label} className="rounded-xl border border-plum-line bg-white/5 px-4 py-3" data-id="element-255" data-mp="3ar0r6epag9xn">
              <span className="block text-[11px] font-semibold uppercase tracking-widest text-gold" data-id="element-256" data-mp="1v9i7fq4ymr1y">
                {item.label}
              </span>
              <span className="mt-1 block text-sm text-white/85" data-id="element-257" data-mp="2fk1joosm6m9q">
                {item.body}
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}